<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="bk_bankname,bk_bankcode"
      placeholder="输入开户银行进行查找"
      ref="searchBar"
    />
    <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">本币余额汇总</label>
            <em class="weui-form-preview__value">{{numberFormat(getTotal('bb_balance'), '#,##0.00')}}</em>
          </div>
          <div class="weui-form-preview__item" v-for="(value, key) in currencyTotalMap" :key="key">
            <label class="weui-form-preview__label">{{key}}余额汇总</label>
            <span class="weui-form-preview__value">{{numberFormat(value, '#,##0.00')}}</span>
          </div>
        </div>
      </div>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link class="weui-cell weui-cell_access" v-for="item in sortedItems" :key="item.bk_code"
        :to="'/finance/journal_list?hq_keyword='+item.bk_name">
        <div class="weui-cell__bd">
          <p>{{item.bk_name}}</p>
          <p class="list-item-muted">{{item.bk_bankcode}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'#,##0.00'">{{item.bb_doublebalance || 0}}</p>
          <span class="list-item-status">{{item.bk_currency}}</span>
        </div>
      </router-link>
    </scroll-list>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/document/bankinformation/list"
    };
  },
  computed: {
    currencyTotalMap() {
      let items = this.items, total = {};
      if (items) {
        items.forEach(item => {
          if (item.bk_currency) {
            total[item.bk_currency] = (total[item.bk_currency] || 0) + (item.bb_doublebalance || 0);
          }
        });
      }
      return total;
    },
    sortedItems() {
      let items = this.items;
      items.sort((i, j) => (j.bb_balance || 0) - (i.bb_balance || 0));
      return items;
    }
  }
};
</script>